import { render, staticRenderFns } from "./CrmRelativeTable.vue?vue&type=template&id=ec65df44&scoped=true"
import script from "./CrmRelativeTable.vue?vue&type=script&lang=js"
export * from "./CrmRelativeTable.vue?vue&type=script&lang=js"
import style0 from "./CrmRelativeTable.vue?vue&type=style&index=0&id=ec65df44&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec65df44",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/crm1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ec65df44')) {
      api.createRecord('ec65df44', component.options)
    } else {
      api.reload('ec65df44', component.options)
    }
    module.hot.accept("./CrmRelativeTable.vue?vue&type=template&id=ec65df44&scoped=true", function () {
      api.rerender('ec65df44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CreateCom/CrmRelativeTable.vue"
export default component.exports